/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAhiSeriesProductDetailPageLinkViewProps } from './ahi-series-product-detail-page-link';
import { Button } from '@msdyn365-commerce-modules/utilities';

export default (props: IAhiSeriesProductDetailPageLinkViewProps) => {
    const { productUrl } = props;
    return (
        <div className='row'>
            <Button className='ms-series-product-link' href={productUrl}>
                {props.resources.linkLabel}
            </Button>
        </div>
    );
};
